import { ClientPortfolioDomainEnum } from "web_myplann/Infrastructure/Api/Api";
import { REPORTING_VALUE_DOMAINS } from "web_myplann/Portfolio/Helpers/portfolioReportingDomains";

const DOMAINS_WITH_CHART: ReadonlySet<ClientPortfolioDomainEnum> = new Set(
	REPORTING_VALUE_DOMAINS.filter(
		(domain) => domain !== ClientPortfolioDomainEnum.LifeInsurance,
	),
);

export const portfolioHasChart = (
	domain: ClientPortfolioDomainEnum | undefined | null,
): boolean =>
	domain !== null && domain !== undefined && DOMAINS_WITH_CHART.has(domain);
